import React from 'react'
import { Grid } from '@mui/material'
import JobChipField from 'components/Drawers/JobDrawer/JobChipField'
import JobCheckboxField from 'components/Drawers/JobDrawer/JobCheckboxField'
import JobRadioGroup from 'components/Drawers/JobDrawer/JobRadioGroup'
import {
  academicOptions,
  ACADEMIC_ICONS,
  visaOptions,
  yesNoOptions,
} from 'components/Drawers/JobDrawer/constants'
import { ACADEMIC_TYPE_HELPER_TEXT } from 'data/fieldHelperText'

const VisaSection = ({ values, setState }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JobChipField
          label='Academic'
          name='academicType'
          options={academicOptions}
          icons={ACADEMIC_ICONS}
          value={values.academicType}
          setState={setState}
          tooltipText={ACADEMIC_TYPE_HELPER_TEXT}
        />
      </Grid>
      <Grid item xs={12}>
        <JobCheckboxField
          label='Visa Sponsorship'
          name='visaIds'
          value={values.visaIds}
          options={visaOptions}
          setState={setState}
        />
      </Grid>
      <Grid item xs={6}>
        <JobRadioGroup
          label='Loan Forgiveness'
          name='loanForgiveness'
          value={values.loanForgiveness}
          options={yesNoOptions}
          setState={setState}
        />
      </Grid>
      <Grid item xs={6}>
        <JobRadioGroup
          label='PSLF Compatible'
          name='pslfCompatible'
          value={values.pslfCompatible}
          options={yesNoOptions}
          setState={setState}
        />
      </Grid>
    </Grid>
  )
}

export default VisaSection
